import { FC } from 'react';
import { useSendCommunicationModal } from '../context/SendCommunicationModalContext';
import { Recipient } from '../types/Recipient';

type CategoryChipProps = {
  recipient: Recipient;
};

const CategoryChip: FC<CategoryChipProps> = ({ recipient }) => {
  const { actions } = useSendCommunicationModal();

  const { name } = recipient;

  return (
    <div className="recipient-chip d-inline-flex align-items-center border rounded-pill me-2 mb-2">
      <span className="recipient-chip__name fw-medium ml-1">{name}</span>
      <button
        type="button"
        onClick={actions.handleRemoveCategoryRecipient}
        className="recipient-chip__remove btn btn-sm p-0 d-flex align-items-center justify-content-center border-0"
      >
        <em className="icon ni ni-cross" />
      </button>
    </div>
  );
};

export default CategoryChip;
